import { createSlice } from "@reduxjs/toolkit";
import { getNotifications, changeStatusNotification } from "./thunk";
export const initialState = {
  notifications: [],
  error: {},
};

const NotificationsSlice = createSlice({
  name: "NotificationsSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getNotifications.fulfilled, (state, action) => {      
      state.notifications = action.payload.data;
    });

    builder.addCase(getNotifications.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(changeStatusNotification.fulfilled, (state, action) => {
     // console.log("action.payload", action.payload.data);
      const index = state.notifications.findIndex(
        (notification) => notification.not_id === action.payload.data.not_id
      );
      state.notifications[index] = action.payload.data

    });

    builder.addCase(changeStatusNotification.rejected, (state, action) => {
      state.error = action.payload.error;
    });
  },
});

export default NotificationsSlice.reducer;
